import { Pipe, PipeTransform } from '@angular/core'

/** A nutrient entry whose nutrient is known, as the type filter guarantees. */
type WithNutrient<N extends { nutrient?: unknown }> = N & { nutrient: NonNullable<N['nutrient']> }

@Pipe({
  name: 'nutrientsActivityType',
})
export class NutrientsActivityTypePipe implements PipeTransform {
  transform<N extends { nutrient?: { type?: string } }>(
    nutrients: N[] | null | undefined,
    type: string,
  ): WithNutrient<N>[] {
    if (!nutrients?.length || !type) return []
    return nutrients.filter((n): n is WithNutrient<N> => n?.nutrient?.type === type)
  }
}
